import React from "react";
import { Navigate } from "react-router-dom";
import { useVictimData } from "contexts/VictimFormDataContext";

const VictimProtectedRoute = ({ children }) => {
  const { victimData } = useVictimData();

  // If victimData is missing or success is not true → block
  if (!victimData || victimData.verified !== true) {
    return <Navigate to="/victim_form" replace />;
  }

  return children;
};


export default VictimProtectedRoute;
